<script lang="ts">
  import PaidInvoiceDetailComponent from '../../components/employer/payment/paidInvoice/detail.svelte';
  
  export let params: { invoiceId?: string } = {};
</script>

<PaidInvoiceDetailComponent invoiceId={params.invoiceId || ''} />

